import axiosInstance from "../services/axiosInstance";

export const userProfile = async (payload = {}) => {
  try {
    const now = new Date();
    const requestPayload = {
      date: payload.date || now.toISOString().slice(0, 10),
      time:
        payload.time ||
        now
          .toLocaleTimeString(undefined, { hour12: false })
          .replace(/\./g, ":"),
      ...payload,
    };

    const response = await axiosInstance.post(
      "console/user/profile",
      requestPayload,
    );

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
